import { keepPreviousData, useQuery } from '@tanstack/react-query';

import VisionMonitorService, {
  VisionMonitorQuery,
} from '@/services/VisionMonitorService';

export const VISION_MONITOR_QUERY_KEY = ['vision-monitor'];

export function useGetVisionMonitorProducts(query: VisionMonitorQuery) {
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: [...VISION_MONITOR_QUERY_KEY, 'products', query],
    queryFn: () => VisionMonitorService.getProducts(query),
    placeholderData: keepPreviousData,
    // Monitoring data: the global 5min staleTime would hide pipeline progress.
    staleTime: 15 * 1000,
  });

  return {
    rows: data?.items ?? [],
    totalItems: data?.totalItems ?? 0,
    totalPages: data?.totalPages ?? 1,
    isLoading: isFetching,
    isError,
    refetch,
  };
}
